import React from "react"
import { Card, Col, Row } from "react-bootstrap"

export const SkeletonStatsCard = () => (
  <Col xs={6} lg={3} className="mb-4">
    <div className="skeleton-card">
      <div className="skeleton skeleton-title"></div>
      <div className="skeleton skeleton-text"></div>
    </div>
  </Col>
)

export const SkeletonChartCard = () => (
  <Card className="dashboard-chart-card">
    <Card.Header>
      <div className="skeleton skeleton-title"></div>
    </Card.Header>
    <Card.Body>
      <div className="skeleton skeleton-chart"></div>
    </Card.Body>
  </Card>
)

export const SkeletonTableCard = ({ title, rows = 3 }) => (
  <Card className="dashboard-table-card">
    <Card.Header>
      <div className="skeleton skeleton-title"></div>
    </Card.Header>
    <Card.Body className="p-0">
      {[...Array(rows)].map((_, index) => (
        <div key={index} className="skeleton-table-row">
          <div className="skeleton skeleton-table-cell"></div>
          <div className="skeleton skeleton-table-cell"></div>
        </div>
      ))}
    </Card.Body>
  </Card>
)

export const SkeletonFilterCard = () => (
  <Card className="dashboard-filter-card">
    <Card.Header>
      <div className="skeleton skeleton-title"></div>
    </Card.Header>
    <Card.Body>
      <Row>
        <Col xs={12} md={4} xl={3}>
          <div
            className="skeleton skeleton-text mb-2"
            style={{ width: "30%" }}
          ></div>
          <div
            className="skeleton skeleton-text"
            style={{ width: "100%", height: "2.5rem" }}
          ></div>
        </Col>
      </Row>
    </Card.Body>
  </Card>
)

export const DashboardSkeleton = () => (
  <div className="dashboard-container">
    <div className="container">
      {/* Section Header Skeleton */}
      <div className="dashboard-section-header">
        <div
          className="skeleton skeleton-title"
          style={{ width: "200px" }}
        ></div>
      </div>

      {/* Stats Cards Skeleton */}
      <Row>
        <SkeletonStatsCard />
        <SkeletonStatsCard />
        <SkeletonStatsCard />
        <SkeletonStatsCard />
      </Row>

      {/* Agent Info Section */}
      <div className="dashboard-section-header">
        <div
          className="skeleton skeleton-title"
          style={{ width: "150px" }}
        ></div>
      </div>

      <Row>
        <Col xs={12}>
          <SkeletonFilterCard />
        </Col>
      </Row>

      {/* Summary Tables Skeleton */}
      <Row>
        <Col xs={12} md={6}>
          <SkeletonTableCard title="Stage Summary" rows={4} />
        </Col>
        <Col xs={12} md={6}>
          <SkeletonTableCard title="Status Summary" rows={4} />
        </Col>
      </Row>

      {/* Charts Skeleton */}
      <Row className="my-4">
        <Col xs={12} md={6}>
          <SkeletonChartCard />
        </Col>
        <Col xs={12} md={6}>
          <SkeletonChartCard />
        </Col>
      </Row>

      {/* Vehicles Section */}
      <div className="dashboard-section-header">
        <div
          className="skeleton skeleton-title"
          style={{ width: "100px" }}
        ></div>
      </div>

      <Row>
        <Col xs={12} md={6} lg={8}>
          <SkeletonTableCard title="Vehicle Status" rows={3} />
          <SkeletonTableCard title="GPS Models" rows={5} />
        </Col>
        <Col xs={12} md={6} lg={4}>
          <SkeletonTableCard title="Vehicle Brands" rows={4} />
        </Col>
      </Row>
    </div>
  </div>
)
